import React from "react"

import { TextField } from "components"
import CurrencyInputComponent from "./CurrencyInputComponent"

const CurrencyInput = props => {
  const { onChange = () => { }, } = props

  const isIntlSupported =
    !!Intl.NumberFormat().formatToParts

  if (isIntlSupported) {
    return (
      <CurrencyInputComponent
        {...props}
      />
    )
  }

  return (
    <TextField
      {...props}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

export default CurrencyInput